module.exports = __webpack_public_path__ + "img/social4.961e0613.svg";